<template>
  <div class="solutionIndex">
    <div class="container">
      <div class="banner">
        <img src="../../assets/solution/kv.png" alt="" srcset="">
        <div class="content">
          <div class="title">解决方案</div>
          <div class="line"></div>
          <div class="descr">SOLUTION</div>
        </div>
      </div>  
      <div class="puzzle-box">
        <div class="puzzle" v-for="(item, index) in puzzleList" :key="index" @click="showdialog(index)">
          <img class="image" :src="item.image" alt="">
          <img class="info" :src="item.infos.length > 0 ? require('@/assets/solution/info.png') : require('@/assets/solution/comesoon.png')" alt="">
          <div class="name">{{item.name}}</div>
          <div class="cover"></div>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="showPopup"
      custom-class="dialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="dialog-box">
          <img class="closebtn" src="../../assets/serve/designer/close.png" @click="closeDialog">
          <img v-for="(img , index) in puzzleList[activeIndex].infos" :src="img" alt="" srcset="" :key="index">
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'SolutionIndex',
  components: {
  },
  data() {
    return {
      puzzleList: [
        {
          image: require('../../assets/solution/puzzle4.png'),
          name: '医养空间',
          infos: [
            require('../../assets/solution/puzzle4/0.png'),
            require('../../assets/solution/puzzle4/1.png'),
            require('../../assets/solution/puzzle4/2.png'),
            require('../../assets/solution/puzzle4/3.png'),
            require('../../assets/solution/puzzle4/4.png'),
            require('../../assets/solution/puzzle4/5.png'),
            require('../../assets/solution/puzzle4/6.png'),
            require('../../assets/solution/puzzle4/7.png'),
            require('../../assets/solution/puzzle4/8.png'),
            require('../../assets/solution/puzzle4/9.png'),
            require('../../assets/solution/puzzle4/10.png'),
          ]
        },
        {
          image: require('../../assets/solution/puzzle2.png'),
          name: '办公空间',
          infos: [
            require('../../assets/solution/puzzle2/0.png'),
            require('../../assets/solution/puzzle2/1.png'),
            require('../../assets/solution/puzzle2/2.png'),
            require('../../assets/solution/puzzle2/3.png'),
            require('../../assets/solution/puzzle2/4.png'),
            require('../../assets/solution/puzzle2/5.png'),
            require('../../assets/solution/puzzle2/6.png'),
            require('../../assets/solution/puzzle2/7.png'),
            require('../../assets/solution/puzzle2/8.png'),
            require('../../assets/solution/puzzle2/9.png')
          ]
        },
        {
          image: require('../../assets/solution/puzzle3.png'),
          name: '酒店空间',
          infos: [
            require('../../assets/solution/puzzle3/0.png'),
            require('../../assets/solution/puzzle3/1.png'),
            require('../../assets/solution/puzzle3/2.png'),
            require('../../assets/solution/puzzle3/3.png'),
            require('../../assets/solution/puzzle3/4.png'),
            require('../../assets/solution/puzzle3/5.png'),
            require('../../assets/solution/puzzle3/6.png'),
            require('../../assets/solution/puzzle3/7.png'),
            require('../../assets/solution/puzzle3/8.png'),
            require('../../assets/solution/puzzle3/9.png'),
            require('../../assets/solution/puzzle3/10.png'),
            require('../../assets/solution/puzzle3/11.png'),
            require('../../assets/solution/puzzle3/12.png'),
            require('../../assets/solution/puzzle3/13.png')
          ]
        },
        {
          image: require('../../assets/solution/puzzle1.png'),
          name: '住宅空间',
          infos: []
        },
        {
          image: require('../../assets/solution/puzzle5.png'),
          name: '教育空间',
          infos: []
        },
        {
          image: require('../../assets/solution/puzzle6.png'),
          name: '托育空间',
          infos: []
        }
      ],
      activeIndex: 0,
      showPopup: false
    }
  },
  methods: {
    showdialog(index) {
      this.activeIndex = index
      if (this.puzzleList[index].infos.length <=0) {
        this.showPopup = false
      } else {
        this.showPopup = true
      }
    },
    closeDialog() {
      this.showPopup = false;
    }
  }
}
</script>

<style lang="less" scoped>
.solutionIndex {
  overflow: hidden;
  .container {
    width: 100%;
    position: relative;
    img {
      width: 1920px;
      vertical-align: middle;
    }
    .banner {
      position: relative;
    }
    .content {
      width: 100%;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      display: flex;
      flex-direction: column;
      align-content: center;
      text-align: center;
      .title {
        font-size: 60px;
        font-weight: 400;
        color: #FFFFFF;
        margin-bottom: 39px;
      }
      .line {
        width: 137px;
        height: 6px;
        background: #4E8B46;
        margin: 0 auto;
      }
      .descr {
        font-size: 48px;
        font-weight: 400;
        color: #FFFFFF;
        margin-top: 46px;
      }
    }
    .puzzle-box {
      width: 1711.5px;
      margin: 38px auto;
      display: flex;
      flex-wrap: wrap;
      .puzzle {
        width: 570.5px;
        height: 751px;
        overflow: hidden;
        position: relative;
        .image {
          width: 100%;
          height: 100%;
          vertical-align: center;
          object-fit: cover;
          transition: all 0.5s linear;
        }
        .info {
          width: 271px;
          height: 95px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          opacity: 0;
          z-index: 4;
          transition: all 0.2s linear;
          cursor: pointer;
        }
        .name {
          width: 100%;
          text-align: center;
          font-size: 30px;
          font-family: FZLanTingHeiS-DB-GB;
          font-weight: 400;
          color: #FFFFFF;
          position: absolute;
          left: 0;
          bottom: 100px;
        }
        .cover {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          background: rgba(0,0,0,.2);
          transition: all 0.5s linear;
        }
        &:hover .cover{
          opacity: 0;
        }
        &:hover .image {
          transform: scale(1.1);
        }
        &:hover .info {
          opacity: 1;
        }
      }
    }
  }
  /deep/ .el-dialog {
    width: 1180px;
    position: absolute;
    top: 34px;
    left: 50%;
    transform: translateX(-50%);
    background: #fff;
    padding: 75px 75px;
    border-radius: 30px;
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
      .dialog-box {
        position: relative;
        .closebtn {
          width: 70px;
          height: 70px;
          position: absolute;
          top: -75px;
          right: -220px;
          cursor: pointer;
        }
        img {
          width: 100%;
          vertical-align: middle;
        }
      }
    }
  }
}
</style>